import { render, staticRenderFns } from "./selectYear.vue?vue&type=template&id=0ce8b0b4&scoped=true"
import script from "./selectYear.vue?vue&type=script&lang=js"
export * from "./selectYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce8b0b4",
  null
  
)

export default component.exports